module.exports = ".wrapper {\n    width: 100%;\n}\n\n.top-menu {\n    width: 100%;\n    margin: 6px 0;\n    padding-bottom: 6px;\n    font-size: 13px !important;\n    border-bottom: lightgray solid 1px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/top-menu/top-menu.component.css
// module id = ./src/app/components/top-menu/top-menu.component.css
// module chunks = main